import { FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';

/**
 * Sort control — select + arah, sejajar tinggi dengan search.
 * options: [{ value: 'nama', label: 'Nama' }, ...]
 * onSort(field) — field null = reset sort
 */
export default function SortBar({ options = [], sortField, sortDirection, onSort }) {
    if (!options.length) return null;

    return (
        <div className="flex items-stretch gap-2 shrink-0">
            <div className="relative w-[120px] sm:w-[160px] md:min-w-[180px] md:w-auto">
                <select
                    value={sortField || ''}
                    onChange={(e) => onSort(e.target.value || null)}
                    className="w-full appearance-none pl-2.5 sm:pl-3 pr-7 py-2.5 border border-zafu-cream-dark rounded-xl text-xs bg-white text-zafu-ink focus:ring-2 focus:ring-zafu-green/15 focus:border-zafu-green-soft h-[42px]"
                    aria-label="Urutkan berdasarkan"
                >
                    <option value="">Urutkan</option>
                    {options.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
                <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-zafu-muted text-xs">▾</span>
            </div>
            <button
                type="button"
                onClick={() => sortField && onSort(sortField)}
                disabled={!sortField}
                className="inline-flex items-center justify-center w-[42px] h-[42px] rounded-xl border border-zafu-cream-dark bg-white text-zafu-green hover:bg-zafu-cream disabled:opacity-40 disabled:cursor-not-allowed shrink-0"
                title={sortDirection === 'asc' ? 'A-Z / Asc' : 'Z-A / Desc'}
                aria-label="Arah sort"
            >
                {sortDirection === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
            </button>
        </div>
    );
}
